import type { TaskStatus } from './TaskStatus'

/**
 * Allowed dispatcher-triggered transitions for an executor-assignment (task).
 * Includes the loop `unloading_started → loading_started` for the next trip.
 */
export interface TaskTransition {
    from: TaskStatus
    to: TaskStatus
    label: string
}

export const TASK_TRANSITIONS: ReadonlyArray<TaskTransition> = [
    { from: 'assigned_executor', to: 'execution_started', label: 'Виконання розпочато' },
    { from: 'execution_started', to: 'loading_started', label: 'Завантаження розпочато' },
    { from: 'loading_started', to: 'arrived_at_unloading', label: 'Прибув на розвантаження' },
    { from: 'arrived_at_unloading', to: 'unloading_started', label: 'Розвантаження розпочато' },
    { from: 'unloading_started', to: 'loading_started', label: 'Завантаження розпочато' },
    { from: 'unloading_started', to: 'completed_by_driver', label: 'Завершено водієм' },
]
